import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { DecimalPipe } from '@angular/common';
import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewEncapsulation
} from '@angular/core';

import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-datatable-r10',
	templateUrl: './datatable-r10.component.html',
	styleUrls: ['./datatable-r10.component.css'],
	encapsulation: ViewEncapsulation.None,
	providers: [DecimalPipe]
})
export class DatatableR10Component extends BaseWidgetComponent implements OnInit, OnChanges {
	@Input() sectionclass: any;
	@Input() datatableconfig: any;
	@Input() nodatamessage: any;
	@Input() showtable: any = true;
	@Input() toplinkdata: any;
	@Input() isemail: boolean;
	@Input() iscustomendpoint: any;
	@Input() uniqueoverwriteid: string;
	@Output() selected = new EventEmitter();
	public sortClicked: boolean = false;

	public cssClasses: any = {
		pagerLeftArrow: '',
		pagerRightArrow: '',
		pagerNext: 'datatable-last-text',
		pagerPrevious: 'datatable-first-text',
		sortAscending: 'fa fa-long-arrow-up',
		sortDescending: 'fa fa-long-arrow-down'
	};
	public records: any;
	public tableColumns: any;
	public defaultSort: any;
	public isVerticalScrollable: boolean;
	public selectedRecord: any = [];
	public isR10: boolean = false;
	public isR13: boolean = false;
	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'big'
	};

	constructor(
		protected analyticsService: AnalyticsService,
		private _decimalPipe: DecimalPipe,
		private analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService);
	}

	ngOnInit() {
		if (typeof this.datatableconfig !== 'object') this.datatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		this.tableColumns = this.generateTableColumns();
		super.ngOnInit();
		this.isVerticalScrollable = this.datatableconfig.isVerticalScrollable ?? false;
		this.defaultSort =
			this.datatableconfig.sortBy && typeof this.datatableconfig.sortBy !== 'string' ? this.datatableconfig.sortBy : [];
		this.isR10 = this.analyticsDataModel.config.version === 'R10' ? true : false;
		this.isR13 =
			this.analyticsDataModel.config.version === 'R13' || this.analyticsDataModel.config.version === 'R1301'
				? true
				: false;
		if (this.isR10) {
			this.cssClasses.pagerNext = 'fa fa-angle-double-right';
			this.cssClasses.pagerPrevious = 'fa fa-angle-double-left';
		}
	}

	ngOnChanges(): void {
		if (this.isemail) {
			if (this.toplinkdata?.length > 0) {
				this.showLoad = false;
				this.hasData = true;
				this.showtable = true;
				if (typeof this.datatableconfig !== 'object')
					this.datatableconfig = JSON.parse(decodeURI(this.datatableconfig));
				this.tableColumns = this.generateTableColumns();
				this.processResponseData(this.toplinkdata);
			} else {
				this.hasData = false;
				this.showtable = false;
			}
		}
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = false;

		if (!this.isemail) {
			if (this.requestSubscription) {
				this.requestSubscription.unsubscribe();
			}
			if (this.iscustomendpoint == 'true') {
				this.requestSubscription = this.analyticsService
					.processCustomServiceRequest(this.key, null, null, null, null, this.uniqueoverwriteid)
					.subscribe((response: any) => {
						this.showLoad = false;
						if (response.success && response.data.length > 0) {
							this.hasData = true;
							this.responseData = response.data;
							this.processResponseData(this.responseData);
						} else {
							this.hasData = false;
						}
					});
			} else {
				this.requestSubscription = this.analyticsService
					.processWidgetRequest(this.key, this.columns, null, this.uniqueoverwriteid)
					.subscribe((response: any) => {
						this.showLoad = false;
						if (response.success && response.data.length > 0) {
							this.hasData = true;
							this.responseData = response.data;
							this.processResponseData(this.responseData);
						} else {
							this.hasData = false;
						}
					});
			}
		} else {
			if (this.toplinkdata?.length > 0) {
				this.showLoad = false;
				this.hasData = true;
				this.showtable = true;
				this.responseData = this.toplinkdata;
				if (typeof this.datatableconfig !== 'object')
					this.datatableconfig = JSON.parse(decodeURI(this.datatableconfig));
				this.tableColumns = this.generateTableColumns();
				this.processResponseData(this.responseData);
			} else {
				this.hasData = false;
				this.showtable = false;
			}
		}
	}

	processResponseData(responseData: any): void {
		this.records = this.generateRows(responseData);
		setTimeout(() => {
			jQuery('.intial-sort-header .sort-btn').addClass('fa fa-long-arrow-down');
		}, 500);
	}

	/**
	 * function to generate the columns for ngx-datatable
	 * it will get columns from columnsconfig attribute
	 */
	generateTableColumns() {
		const sortedColumnConfig: any = _.sortBy(this.datatableconfig.columns, 'columnOrder');
		let columns: any = [];
		for (const colConfig of sortedColumnConfig) {
			var permission = colConfig.permissionWithBooleanCheck;
			if (permission) {
				// If doesnt have the permission then dont add to datatable.
				if (!this.analyticsDataModel.checkComponentForPermission(colConfig)) continue;
			}
			const colObj: any = {};
			colObj.name = colConfig.columnName;
			colObj.prop = colConfig.columnKey;
			colObj.type = colConfig.columnType;
			colObj.headerClass = colConfig.columnHeaderClass;
			colObj.cellClass = colConfig.columnCellClass;
			colObj.hasProgressBar = colConfig.columnHasProgressBar;
			colObj.showTitle = colConfig.columnShowTitle;
			colObj.columnKey = colConfig.columnKey;
			colObj.resizeable = false;
			colObj.draggable = false;
			colObj.columnHasTooltip = colConfig.columnHasTooltip ?? false;
			colObj.columnTooltip = colConfig.columnTooltip;
			colObj.prepend = colConfig.columnPrepend ?? '';
			colObj.flexGrow = colConfig.columnFlexGrow ?? 1;
			colObj.headerCheckboxable = colConfig.headerCheckboxable ?? false;
			colObj.checkboxable = colConfig.columnCheckboxable ?? false;
			//adding pipe for formatting the values
			switch (colConfig.columnType) {
				case 'number':
					colObj.pipe = this.decimalNumberPipe();
					break;
				case 'float':
					colObj.pipe = this.decimalNumberPipe('1.2-2', colObj.prepend, '--');
					break;
				default:
					break;
			}

			if (!colConfig.columnType && colObj.prepend) {
				colObj.pipe = this.appendSymbolPipe(colObj.prepend, '--');
			}

			columns.push(colObj);
		}
		return columns;
	}

	/**
	 * function to generate the rows for datatable
	 * @param responseData
	 */
	generateRows(responseData: any) {
		const processedData = [];
		for (const responseObj of responseData) {
			processedData.push(this.getResponseObj(responseObj));
		}
		return processedData;
	}

	/**
	 * function to add columns present in the databtable config
	 * @param response
	 */
	getResponseObj(response: any) {
		const record = {};
		for (const column of this.tableColumns) {
			record[column.prop] = response[column.prop];
		}
		return record;
	}

	/**
	 * function to emit selected places
	 * @param $event
	 */
	onSelect($event: any) {
		if ($event.selected) {
			this.selected.emit({ data: $event.selected });
		}
	}

	//function for formatting the number value
	decimalNumberPipe(format: any = '1.0-0', prepand: string = '', nullValue: string = '--') {
		return {
			transform: (value: any) => {
				if (format === '1.2-2' && value >= 100) {
					return '100' + prepand;
				}
				return value && !isNaN(value) ? this._decimalPipe.transform(value, format) + prepand : nullValue;
			}
		};
	}

	//function for adding the symbol
	appendSymbolPipe(symbol: string, nullValue: string = '--') {
		return {
			transform: (value: string) => {
				return value ? value + symbol : nullValue;
			}
		};
	}

	//funciton to check only one is selected
	singleSelectCheck = (row: any) => {
		return this.selectedRecord.indexOf(row) === -1;
	};

	onSort(event: any): void {
		setTimeout(() => {
			if (!event.column.headerClass || !event.column.headerClass.includes('intial-sort-header')) {
				jQuery('.intial-sort-header .sort-btn').removeClass('fa fa-long-arrow-down');
			}
			jQuery('.datatable-header-cell.sortable.text-right').removeClass('intial-sort-header');
		}, 100);
	}
}
